import VenueTypeDto from 'common/dto-types/venue-type-dto';

const VenueTypeCell = ({ value }: { value: VenueTypeDto }): JSX.Element => {
    if (!value) return <></>;

    return <p>{value.name}</p>;
};

export default VenueTypeCell;
